var map = {
	"./hu/admin.json": [
		6318,
		318
	],
	"./hu/cart.json": [
		7904,
		904
	],
	"./hu/collection.json": [
		8055,
		55
	],
	"./hu/countries.json": [
		8126,
		126
	],
	"./hu/errors.json": [
		3935,
		935
	],
	"./hu/invoices.json": [
		7964,
		964
	],
	"./hu/liveOrders.json": [
		8291,
		291
	],
	"./hu/product.json": [
		6515,
		515
	],
	"./hu/quotations.json": [
		9788,
		788
	],
	"./hu/translation.json": [
		4681,
		184
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8140;
module.exports = webpackAsyncContext;